export default __webpack_public_path__ + "static/08-2281491c3dabba8de6f4ae526143eb06.png";